module Omni.Core.Constants {

  export interface IAppConfig {
    DebugMode: boolean;
  }

  class AppConfig {
    DebugMode: boolean;

    constructor() {
      this.DebugMode = false;
    }
  }

  function appConfig(): AppConfig {
    const config = new AppConfig();

    // Usage: Place an <input name='ngDebug' value='True' />
    const debugConfig = angular.element(document.querySelectorAll("input[name='ngDebug']"));
    if (debugConfig && debugConfig.length > 0) {
      config.DebugMode = debugConfig ? debugConfig.val() === "True" : false;
    }

    return config;
  }

  ngModule.constant("appConfig", appConfig());
}